var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSouthafrica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51471 20.4853C-1.17157 15.799 -1.17157 8.20102 3.51471 3.51469C3.51438 3.51521 10.4348 12 10.4348 12L3.51471 20.4853Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 12L1.59156 6.02405C1.31739 6.50063 1.07561 6.99806 0.867859 7.51294L5.34484 12L0.868 16.4874C1.07556 17.0019 1.31711 17.499 1.59109 17.9753L10.4348 12Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8984 10.4348H10.4345L3.51458 3.51488C2.76889 4.26056 2.12103 5.10389 1.59153 6.0241L7.55586 12L1.59106 17.9752C2.12056 18.8956 2.7687 19.7392 3.51458 20.4851L10.4345 13.5652H23.8984C23.9651 13.0529 24 12.5305 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69397 21.5192C6.71752 23.0746 9.2505 24 12 24C17.5443 24 22.2096 20.2396 23.5866 15.1304H11.0828L4.69397 21.5192Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5866 8.86955C22.2096 3.76036 17.5443 0 12 0C9.2505 0 6.71752 0.925359 4.69397 2.48077L11.0828 8.86955H23.5866Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthafrica);
export default __webpack_public_path__ + "static/media/southafrica.2e913914a5ff2e39ea47f4195dab8d48.svg";
export { ForwardRef as ReactComponent };